<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Form Kaldik'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')" />
          </template>
          <template v-slot:body>
            <v-card-title></v-card-title>
            <b-form @submit.prevent="onSubmit">
              <div class="row">
                <div class="col-lg-6">

                  <b-form-group label="Tahun Akademik" class="mb-5">
                    <!-- <SelectAngkatan :selectedValue="request.angkatan" :changegeneration="changeGeneration">
                    </SelectAngkatan> -->
                    <Select2 v-model="request.tahun_akademik" :options="generations" @change="selectAngkatan()" />
                  </b-form-group>

                  <!-- <b-form-group label="Program Studi">
                    <SelectProdi :selectedValue="request.id_prodi" :changeprodi="changeProgram">
                    </SelectProdi>
                  </b-form-group> -->

                  <b-form-group label="Semester">
                    <Select2 v-model="request.semester" :options="optionsSemester" />
                  </b-form-group>

                  <b-form-group label="Detail Kegiatan">
                    <b-form-textarea v-model="request.detail" rows="3"></b-form-textarea>
                  </b-form-group>

                  <!-- <b-form-group label="Warna Kalendar">
                    <b-form-input v-model="request.kode_warna" type="color" style="width: 6%"></b-form-input>
                  </b-form-group> -->
                </div>
                <div class="col-lg-6">
                  <b-form-group label="Tanggal">
                    <!-- <b-form-input id="tambahTanggal" type="date" required></b-form-input> -->
                    <vc-date-picker v-model="range" mode="date" is-range :model-config="{
                      type: 'string',
                      mask: 'YYYY-MM-DD',
                    }">
                      <template v-slot="{ inputValue, inputEvents, isDragging }">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex">
                            <div class="calendar-btn p-2 border bg-gray-100">
                              <i class="fa fa-calendar" aria-hidden="true"></i>
                            </div>
                            <input class="calendar-form flex-grow pl-8 pr-2 py-1 bg-gray-100 border w-full"
                              :class="isDragging ? 'text-gray-600' : 'text-gray-900'" :value="inputValue.start"
                              v-on="inputEvents.start" />
                          </div>
                          <span class="flex-shrink-0 m-2">
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                          </span>
                          <div class="d-flex">
                            <div class="calendar-btn p-2 border bg-gray-100">
                              <i class="fa fa-calendar" aria-hidden="true"></i>
                            </div>
                            <input class="calendar-form flex-grow pl-8 pr-2 py-1 bg-gray-100 border w-full"
                              :class="isDragging ? 'text-gray-600' : 'text-gray-900'" :value="inputValue.end"
                              v-on="inputEvents.end" />
                          </div>
                        </div>
                      </template>
                    </vc-date-picker>
                  </b-form-group>

                  <b-form-group label="Angkatan">
                    <Select2 v-model="request.angkatan" :options="angkatan" />
                  </b-form-group>

                  <b-form-group label="Pilih Kegiatan">
                    <SelectKegiatan :selectedValue="request.id_kegiatan" :changekegiatan="changeKegiatan">
                    </SelectKegiatan>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6"></div>
                <div class="col-lg-6" style="display: flex;">
                  <b-button type="submit" variant="primary" style="margin-left: auto;"
                    onclick="store()">Simpan</b-button>
                  <router-link to="/academic/academic-calendar" v-slot="{ navigate }">
                    <button @click="navigate" role="link">
                      <b-button type="reset" variant="danger" class="ml-2" style="margin-left: auto;">Batal</b-button>
                    </button>
                  </router-link>
                </div>
              </div>
            </b-form>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import SelectProdi from "@/view/content/components/select/SelectProdi.vue"
import SelectKegiatan from "@/view/content/components/select/SelectKegiatan.vue"
// import SelectAngkatan from "@/view/content/components/select/SelectAngkatan.vue"
import axios from "axios";
import { ref } from 'vue';

export default {
  data() {
    return {
      range: {
        start: new Date().toISOString().slice(0, 10),
        end: new Date().toISOString().slice(0, 10),
      },
      props: this.$route.params.item
        ? JSON.parse(this.$route.params.item)
        : null,

      selected: null,

      selectedstudyPrograms: null,
      optionsstudyPrograms: [{ key: null, text: "--Pilih Program Studi--" }],
      selectedKegiatan: null,
      optionsKegiatan: [
        { key: null, text: "--Pilih Kegiatan--" },
      ],
      optionsSemester: [
        { id: 1, text: "1" },
        { id: 2, text: "2" },
        { id: 3, text: "3" },
        { id: 4, text: "4" },
        { id: 5, text: "5" },
        { id: 6, text: "6" },
        { id: 7, text: "7" },
        { id: 8, text: "8" }
      ],
      angkatan:[],

      dataLogin: JSON.parse(localStorage.getItem("dataLogin")),

      request: {
        key: null,
        id_prodi: null,
        angkatan: null,
        id_kegiatan: null,
        tahun_akademik: null,
        hari: null,
        total_jam_pelajaran: null,
        pertemuan_ke: null,
        jam_mulai: null,
        jam_selesai: null,
        start_real_time_hour: null,
        end_real_time_hour: null,
        tgl_mulai: null,
        tgl_akhir: null,
        semester: null,
        detail: null,
        tingkat: null
        // kode_warna: null
      },
      generations: [],
      arrAngkatan: []
    };
  },
  components: {
    KTCodePreview,
    // SelectProdi,
    SelectKegiatan,
    // SelectAngkatan
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Akademik" },
      { title: "Form Kaldik" }
    ]);
    
    await this.getAngkatan()
    this.getDataAngkatan()

    if (this.props != null) {
      this.range = { start: null, end: null }
      this.request.key = this.props.key;
      const result = await axios.get(`master/academic-calender/${this.request.key}/detail`)
      this.request.angkatan = result.data.data.angkatan;
      this.request.tahun_akademik = result.data.data.tahun_akademik;
      this.request.semester = result.data.data.semester_kaldik;
      this.request.id_prodi = result.data.data.id_prodi;
      this.request.id_kegiatan = result.data.data.id_kegiatan;
      this.request.detail = result.data.data.detail;
      this.range = ref({
        start: new Date(result.data.data.tgl_mulai),
        end: new Date(result.data.data.tgl_akhir),
      });
      // this.request.kode_warna = result.data.data.kode_warna;
    }

  },
  methods: {
    async getAngkatan() {
      try {
        await axios.get('master/generations')
          .then(response => {
            if (response.status == 200) {
              response.data.data.some((e, index) => {
                if (e.status == true) {
                  var object = { "id": e.key, "text": e.tahun + " / " + e.tahun_akhir + " " + e.semester}
                  // var object = { "id": e.key, "text": e.tahun + " " + e.semester }
                  this.generations.push(object);
                }
                return index > e.length;
              });
            }
          })
        this.generations.sort((a, b) => {
          if (b.text < a.text) return -1;
          if (b.text > a.text) return 1;
          return 0;
        });
      } catch (err) {
        // this.$swal(err);
      }
    },

    async getDataAngkatan() {
      await axios.get('master/angkatan')
          .then(response => {
            if (response.status == 200) {
              response.data.data.map((e, index) => {
                if(e.status == true) {
                  var object = { id: e.key, text: e.nama_angkatan }
                  // var object = { "id": e.key, "text": e.tahun + " " + e.semester }
                  this.angkatan.push(object);
                }
                return index > e.length;
              });
            }
          })
          this.sortedDes();
      },
      sortedDes() {
          return this.angkatan.sort((a, b) => {
            if (a.id && b.id) {
              if (b.text < a.text) return -1;
              if (b.text > a.text) return 1;
              return 0;
            }
          });
      },

    selectAngkatan() {
      let index = this.arrAngkatan.findIndex(x => x.id === this.request.angkatan);
      this.request.tahun_akademik = this.arrAngkatan[index].tahun_akademik
    },

    changeProgram: function (selected) {
      this.request.id_prodi = selected;
    },

    // changeGeneration: function (selected) {
    //   this.request.angkatan = selected;
    // },

    changeKegiatan: function (selected) {
      this.request.id_kegiatan = selected;
    },

    async onSubmit() {
      this.request.tgl_mulai = this.range.start
      this.request.tgl_akhir = this.range.end
      if (this.request.semester == '1' || this.request.semester == '2') {
        this.request.tingkat = 'I'
      } else if (this.request.semester == '1' || this.request.semester == '2') {
        this.request.tingkat = 'I'
      } else if (this.request.semester == '3' || this.request.semester == '4') {
        this.request.tingkat = 'II'
      } else if (this.request.semester == '5' || this.request.semester == '6') {
        this.request.tingkat = 'III'
      } else if (this.request.semester == '7' || this.request.semester == '8') {
        this.request.tingkat = 'IV'
      }
      const form = this.request;

      if (form.key === null) {
        // store
        this.store(form);
      } else {
        // update
        this.update(form);
      }
    },

    async store(form) {
      try {
        const formData = new FormData()
        formData.append("tahun_akademik", form.tahun_akademik);
        formData.append("tgl_mulai", form.tgl_mulai);
        // formData.append("id_prodi", form.id_prodi);
        formData.append("angkatan", form.angkatan);
        formData.append("semester", form.semester);
        formData.append("tingkat", form.tingkat);
        formData.append("id_kegiatan", form.id_kegiatan);
        formData.append("tgl_akhir", form.tgl_akhir);
        formData.append("detail", form.detail);
        // formData.append("kode_warna", form.kode_warna);
        const result = await axios.post(`master/academic-calender/`, formData)
        if (result.data.meta.code == 200) {
          this.$router.push({
            name: "academic-calendar",
            params: { createOrUpdate: "Sukses Store Data" },
          });
          this.$swal(`Success Store Data`);
          // this.getData()
        } else {
          await this.$swal(`${result.data.meta.message}`);
        }
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    async update(form) {
      try {
        var formData = {
          tahun_akademik: form.tahun_akademik,
          tgl_mulai: form.tgl_mulai,
          // id_prodi: form.id_prodi,
          angkatan: form.angkatan,
          semester: form.semester,
          tingkat: form.tingkat,
          id_kegiatan: form.id_kegiatan,
          tgl_akhir: form.tgl_akhir,
          detail: form.detail,
        };
        const result = await axios.put(`master/academic-calender/${form.key}`, formData)

        if (result.data.meta.code == 200) {
          this.$router.push({
            name: "academic-calendar",
            params: { createOrUpdate: "Sukses Update Data" },
          });
          this.$swal(`Success Update Data`);
          // this.getData()
        } else {
          await this.$swal(`${result.data.meta.message}`);
        }
      } catch (err) {
          this.$swal(`Failed`);
      }
    },
  },
};
</script>
